export const TBAFinish = 'TBA';
export const CustomFinish = '800';
export const CustomRalFinish = 'RAL';
